import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

export type AlertVariant = "success" | "error" | "warning" | "info";

interface AlertProps {
  variant?: AlertVariant;
  title?: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}

const STYLES: Record<AlertVariant, { wrap: string; icon: string; iconClass: string }> = {
  success: { wrap: "border-success-200 bg-success-50 text-success-900", icon: "ri-checkbox-circle-fill", iconClass: "text-success-600" },
  error: { wrap: "border-danger-200 bg-danger-50 text-danger-900", icon: "ri-close-circle-fill", iconClass: "text-danger-600" },
  warning: { wrap: "border-warning-200 bg-warning-50 text-warning-900", icon: "ri-error-warning-fill", iconClass: "text-warning-600" },
  info: { wrap: "border-info-200 bg-info-50 text-info-900", icon: "ri-information-fill", iconClass: "text-info-600" },
};

export function Alert({ variant = "info", title, children, action, className }: AlertProps) {
  const style = STYLES[variant];
  return (
    <div className={cn("flex items-start gap-3 rounded-md border px-3.5 py-3", style.wrap, className)} role="alert">
      <i className={cn("mt-0.5 flex-none text-lg", style.icon, style.iconClass)} />
      <div className="flex-1 text-sm">
        {title ? <p className="font-semibold">{title}</p> : null}
        {children ? <div className={cn("text-sm", title && "mt-0.5")}>{children}</div> : null}
      </div>
      {action ? <div className="flex-none">{action}</div> : null}
    </div>
  );
}